import { List, Text } from '@mantine/core';

/** Ostrzeżenia przy wydaniu dokumentu (nie blokują wydania) — np. brak NIP-u lub rachunku firmy. */
export function IssueWarnings({ items }: { items: string[] }) {
  if (items.length === 1) return <Text size="sm">{items[0]}</Text>;
  return (
    <List size="sm" spacing={2}>
      {items.map((i) => (
        <List.Item key={i}>{i}</List.Item>
      ))}
    </List>
  );
}
